import { array, date, mixed, object, string } from 'yup';
import { TFunction } from 'react-i18next';
import { isSameOrAfterToday } from 'utils';
import moment from 'moment';

export const isAdmissionDateValid = (date?: string | Date) => {
  const selectedDate = moment(date);

  if (!selectedDate || !selectedDate.isValid()) return false;
  return isSameOrAfterToday(selectedDate);
};

export interface PreClaimFormState {
  patientName: string;
  admissionDate: string;
  hospital: string;
  doctor: string;
  diagnosis: string;
  surgery: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  admissionOrReferralLetters: any;
}

export const getPreClaimSchema = (t: TFunction) =>
  object({
    patientName: string().required(t('preAuthRequest.requestInformation.patient.error')),
    admissionDate: date()
      .required(t('preAuthRequest.requestInformation.admissionDate.error'))
      .test('admission-date-valid', t('preAuthRequest.requestInformation.admissionDate.invalid'), (selectedDate) =>
        isAdmissionDateValid(selectedDate),
      ),
    hospital: string().required(t('preAuthRequest.requestInformation.hospital.error')),
    doctor: string().required(t('preAuthRequest.requestInformation.doctor.error')),
    diagnosis: string().required(t('preAuthRequest.requestInformation.diagnosis.error')),
    surgery: string().required(t('preAuthRequest.requestInformation.surgery.error')),
    admissionOrReferralLetters: array(mixed()),
  }).required();
